import type { ReactNode } from 'react';
import { useViewport } from '@/lib/viewport';
import { IconBtn } from './IconBtn';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  width?: number;
  destructive?: boolean;
}

export function Dialog({
  open,
  onClose,
  title,
  subtitle,
  footer,
  children,
  width = 560,
  destructive,
}: DialogProps) {
  const { isMobile } = useViewport();
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'var(--bx-scrim)',
        display: 'flex',
        alignItems: isMobile ? 'flex-end' : 'center',
        justifyContent: 'center',
        zIndex: 100,
        padding: isMobile ? 0 : 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: isMobile ? '100%' : width,
          maxHeight: isMobile ? '92vh' : 'calc(100vh - 48px)',
          background: '#fff',
          borderRadius: 'var(--bx-radius-lg)',
          borderBottomLeftRadius: isMobile ? 0 : 'var(--bx-radius-lg)',
          borderBottomRightRadius: isMobile ? 0 : 'var(--bx-radius-lg)',
          boxShadow: 'var(--bx-shadow-pop)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {isMobile && (
          <div
            style={{
              width: 36,
              height: 4,
              background: 'var(--bx-border)',
              borderRadius: 9999,
              margin: '8px auto 0',
            }}
          />
        )}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid var(--bx-border-muted)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 16,
          }}
        >
          <div style={{ minWidth: 0, flex: 1 }}>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: destructive ? 'var(--bx-error)' : 'var(--bx-text-heading)',
              }}
            >
              {title}
            </div>
            {subtitle && (
              <div style={{ fontSize: 12.5, color: 'var(--bx-text-muted)', marginTop: 4 }}>
                {subtitle}
              </div>
            )}
          </div>
          <IconBtn name="x" onClick={onClose} title="Đóng" />
        </div>
        <div style={{ padding: 20, overflowY: 'auto', flex: 1, minHeight: 0 }}>{children}</div>
        {footer && (
          <div
            style={{
              padding: '12px 20px',
              borderTop: '1px solid var(--bx-border-muted)',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              background: 'var(--bx-surface-2)',
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
